<template>
    <div class="tracker-form-body-inputs">
        <app-stepper-section label="Rastreador" class="tracker-stepper-section">
            <Form ref="form" @submit="emitValid">
                <app-select
                    class="tracker-type-select"
                    :data-title="
                        $t('message.trackers.message.selectTrackerType')
                    "
                    :clearable="true"
                    :data-search="false"
                    :value="value.type"
                    :data-items="types"
                    @input="sendFormData($event, 'type')"
                />

                <text-field
                    :value="value.name"
                    @blur="sendFormData($event, 'name')"
                    :name="$t('message.trackers.message.name')"
                    class="input"
                    :label="$t('message.trackers.message.name')"
                    validate="required"
                    :error-messages="
                        errors.collect($t('message.trackers.message.name'))
                    "
                ></text-field>

                <text-field
                    :value="value.trackerIdentification"
                    @blur="sendFormData($event, 'trackerIdentification')"
                    :name="nameTrackerIdentification"
                    class="input"
                    :label="nameTrackerIdentification"
                    validate="required"
                    :error-messages="errors.collect(nameTrackerIdentification)"
                ></text-field>

                <text-field
                    :value="value.trackerTokenOrSecret"
                    @blur="sendFormData($event, 'trackerTokenOrSecret')"
                    :name="nameTrackerTokenOrSecret"
                    class="input"
                    :label="nameTrackerTokenOrSecret"
                    validate="required"
                    :error-messages="errors.collect(nameTrackerTokenOrSecret)"
                ></text-field>

                <checkbox
                    class="checkbox-default"
                    v-model="value.isDefault"
                    :label="$t('message.trackers.message.setAsDefaultTracker')"
                />

                <SSIDFilter
                    v-model="value.ssidFilter"
                    :is-all-selected="value.allSsidSelected"
                    @update-all-selected="
                        sendFormData($event, 'allSsidSelected')
                    "
                />
            </Form>
        </app-stepper-section>
    </div>
</template>

<script>
import { cloneDeep } from "lodash";
import AppStepperSection from "@components/StepperSection";
import AppSelect from "@components/Select";
import TextField from "@components/form/TextField.vue";
import Form from "@components/form/Form.vue";
import Checkbox from "../../../../../Checkbox";
import SSIDFilter from "../../../../ssid/SSIDFilter.vue";

export default {
    components: {
        AppSelect,
        AppStepperSection,
        Checkbox,
        TextField,
        Form,
        SSIDFilter,
    },
    data() {
        return {
            page: 0,
            loginType: undefined,
            form: {
                name: undefined,
                type: undefined,
                isDefault: false,
                integrationId: undefined,
                ssidFilter: [],
            },
        };
    },

    props: {
        test: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
        },
        value: {
            type: Object,
        },
    },

    computed: {
        isEdit() {
            return !!this.item;
        },

        types() {
            return [
                {
                    id: "FACEBOOK_PIXEL",
                    label: "Pixel Meta",
                    imgSrc: "/images/facebook-logo-blue.png",
                    imgAlt: "facebook-logo",
                },
                {
                    id: "GOOGLE_ANALYTICS",
                    label: "Google Analytics",
                    imgSrc: "/images/google-analytics.svg",
                    imgAlt: "google-analytics-logo",
                },
            ];
        },

        isFacebookType() {
            return this.value.type === "FACEBOOK_PIXEL";
        },

        isGoogleAnalyticsType() {
            return this.value.type === "GOOGLE_ANALYTICS";
        },

        nameTrackerIdentification() {
            return this.isGoogleAnalyticsType
                ? "Measurement Id"
                : this.$t("message.trackers.message.pixelId");
        },

        nameTrackerTokenOrSecret() {
            return this.isGoogleAnalyticsType
                ? "Api Secret"
                : this.$t("message.trackers.message.accessToken");
        },
    },

    methods: {
        emitBack() {
            this.$emit("back");
        },
        hideModal() {
            this.emitInput(false);
        },
        emitValid() {
            this.$emit("valid");
        },
        async validate() {
            await this.$validator.validateAll();

            if (this.$validator.errors.items.length !== 0)
                return this.$emit("to-general-tab");

            this.$emit("valid");
        },
        sendFormData(event, key) {
            const newVal = cloneDeep(this.value);
            newVal[key] =
                typeof event === "string" || !event
                    ? event
                    : event.target.value;
            this.$emit("input", newVal);
        },
    },
};
</script>

<style lang="scss" scoped>
.tracker-type-select {
    margin: 0 auto 15px;
}
.tracker-form-body-inputs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.tracker-stepper-section {
    display: inline;
    padding-bottom: 10px;
    padding-top: 10px;
}
.checkbox-default {
    padding-top: 10px;
}
</style>
